import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import { store } from "@/store/index";
import { getToken } from '@/utils/auth'

import { i18n } from "../locale";


const instance = axios.create({
    // baseURL: "http://192.168.1.21",
    baseURL: "https://interestingtv.vip",
    timeout: 5000, //请求时间、1000是一秒
});
instance.interceptors.request.use(config => {
    config.headers["Accept-Language"] = localStorage.getItem('lang') || 'zh';
    // 获取的token
    if (localStorage.getItem('token')) {
        config.headers['token'] = localStorage.getItem('token')
    } 


    return config;
});
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    const res = response.data
    // if(res.code==0){
    //     Message({
    //         message: response.data.msg || 'Error',
    //         type: 'error',
    //         duration: 5 * 1000
    //       })
    // }
    return res;
}, function (error) {
    Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default instance